// Copyright (c) Docugami, Inc. All rights reserved.

import { useState, useEffect } from "react";
import { createSelectEntryTitles } from "store/reports/selectors";
import { useAppSelector } from "./redux";
import { selectDocsetLabels } from "store/dgml/dgmlSelectors";

const selectEntryTitles = createSelectEntryTitles();
export function useLabelSearchSuggestions(searchFilter: string, docsetId: string, reportId?: string, hide?: boolean) {
    const allLabels = useAppSelector(state => !!reportId ? selectEntryTitles(state, reportId) : selectDocsetLabels(state, docsetId));

    const [showSuggestions, setShowSuggestions] = useState(false);
    const [suggestions, setSuggestions] = useState<string[]>([]);

    useEffect(() => {
        if (searchFilter && !hide) {
            const filtered = allLabels.filter(
                label => label.toLowerCase().startsWith(searchFilter.toLowerCase()) && label !== searchFilter
            );
            setSuggestions(filtered);
            setShowSuggestions(filtered.length > 0);
        } else {
            setSuggestions([]);
            setShowSuggestions(false);
        }
    }, [searchFilter, allLabels, hide]);

    return {
        suggestions,
        showSuggestions,
        setShowSuggestions
    }
}